import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Gaziantep'e gitmek için en iyi zaman hangisi?",
    a: "Gaziantep'i ziyaret etmek için en ideal dönemler Mart–Mayıs ve Eylül–Kasım aylarıdır. İlkbaharda hava ılıman ve yeşildir; sonbaharda ise fıstık hasadı dönemi olduğundan şehir ayrı bir canlılık kazanır. Yaz aylarında (Haziran–Ağustos) sıcaklık 38–40°C'ye ulaşabilir. Kış ayları ise soğuk ama yağışlı geçer; bu dönemde şehir daha sakin ve otantik bir atmosfer sunar.",
  },
  {
    q: "Gaziantep'te mutlaka yenilmesi gereken yiyecekler nelerdir?",
    a: "Gaziantep, UNESCO Gastronomi Şehri unvanını hak eden bir mutfak cennetidir. Mutlaka tatmanız gerekenler: fıstıklı baklava (İmam Çağdaş veya Koçak Baklava), sabah katmeri (kaymak ve fıstıklı), beyran çorbası (sabah 6'dan itibaren servis edilir), fıstıklı kebap, lahmacun, ali nazik (közlenmiş patlıcan üzerine yoğurt ve kuzu eti), kibe (içli köfte) ve Antep fıstığı. Tahmis Kahvesi'nde Türk kahvesi içmeyi de ihmal etmeyin.",
  },
  {
    q: "Gaziantep'te mutlaka görülmesi gereken yerler hangileri?",
    a: "Zeugma Mozaik Müzesi (dünyanın en büyük mozaik müzesi, 'Çingene Kızı' mozaiği), Gaziantep Kalesi (Roma ve Bizans döneminden kalma), Bakırcılar Çarşısı, Zincirli Bedesten, Tahmis Kahvesi (1635'ten bu yana), Emine Göğüş Mutfak Müzesi, Gaziantep Arkeoloji Müzesi ve Kurtuluş Camii (eski Rum kilisesi) şehrin başlıca noktalarıdır. Çevre için Halfeti (siyah güller ve tekne turu) ve Rumkale de mutlaka görülmeli.",
  },
  {
    q: "Gaziantep'e nasıl gidilir?",
    a: "Gaziantep Havalimanı, İstanbul, Ankara ve İzmir'den direkt uçuşlarla bağlantılıdır; İstanbul'dan uçuş süresi yaklaşık 1,5 saattir. Ankara'dan otobüsle yaklaşık 7 saat, İstanbul'dan ise 12–13 saat sürer. Şehir içinde taksi ve dolmuş kullanılabilir; tarihi şehir merkezi yürüyerek de gezilebilir.",
  },
  {
    q: "Zeugma Mozaik Müzesi neden bu kadar önemli?",
    a: "Zeugma Mozaik Müzesi, dünyanın en büyük mozaik müzesi olup 1.700 metrekarelik sergi alanında Roma dönemine ait eşsiz mozaikler barındırmaktadır. Birecik Barajı'nın suları altında kalacak olan antik Zeugma kentinden kurtarılan bu mozaikler, özellikle 'Çingene Kızı' olarak bilinen kadın portresiyle dünya çapında ün kazanmıştır. Müze, 2011 yılında Avrupa Konseyi Müze Ödülü'ne layık görülmüştür.",
  },
  {
    q: "Gaziantep baklavası neden bu kadar ünlü?",
    a: "Gaziantep baklavası, bölgeye özgü Antep fıstığı, ince yufka ve özel şerbetiyle dünya genelinde tanınan bir lezzettir. Şehirde 400'den fazla yemek çeşidi bulunmakla birlikte baklava, Gaziantep'in gastronomi kimliğinin simgesidir. Fıstıklı baklava, sütlü nuriye, kuru baklava ve bülbül yuvası başlıca çeşitlerdir. En güvenilir adresler: İmam Çağdaş (1887'den bu yana), Koçak Baklava ve Güllüoğlu.",
  },
  {
    q: "Halfeti nerede ve nasıl gidilir?",
    a: "Halfeti, Gaziantep'e yaklaşık 80 km uzaklıkta Şanlıurfa iline bağlı bir kasabadır. Özel araçla yaklaşık 1 saat sürer; Gaziantep veya Şanlıurfa'dan minibüs seferleri de mevcuttur. Fırat Nehri kıyısındaki bu romantik kasabada tekne turlarıyla su altındaki cami minaresini görebilir, dünyada yalnızca burada yetişen siyah gülleri (Nisan–Haziran) görebilirsiniz. Gaziantep'ten günübirlik ziyaret için idealdir.",
  },
  {
    q: "Gaziantep'te Antep fıstığı nasıl satın alınır?",
    a: "Gaziantep, dünyanın en kaliteli Antep fıstığının üretildiği şehirdir. Ekim–Kasım aylarında hasat edilen taze fıstıklar, tarihi çarşıdaki fıstıkçılarda satılmaktadır. Taze fıstık, eski fıstıktan çok daha lezzetlidir; kabuğu açık yeşil olan fıstıklar en tazesidir. Bakırcılar Çarşısı ve Zincirli Bedesten çevresindeki dükkanlar en güvenilir adresler arasındadır. Vakumlu paketlerde satın almak tazeliği korur.",
  },
  {
    q: "Gaziantep'te kaç gün geçirmek gerekir?",
    a: "Gaziantep şehir merkezini (Zeugma Müzesi, kale, çarşılar) görmek için 2 gün yeterlidir. Halfeti ve Rumkale'yi eklerseniz 3 gün idealdir. Şanlıurfa (Göbeklitepe, Balıklıgöl) ve Mardin'i de kapsayan bir Güneydoğu turu için 7–10 gün ayırabilirsiniz. Gastronomi odaklı bir ziyaret için ise 3–4 gün sabah katmerinden gece baklavasına kadar her öğünde farklı bir lezzet keşfetmenizi sağlar.",
  },
  {
    q: "Gaziantep'te konaklama seçenekleri nelerdir?",
    a: "Gaziantep'te tarihi hanlar ve konaklarda konaklama deneyimi yaşamak şiddetle tavsiye edilir. Sirehan Hotel (tarihi han içinde), Anadolu Evleri (tarihi konak), Novotel Gaziantep (şehir merkezinde konforlu seçenek) ve Dedeman Gaziantep başlıca konaklama seçenekleridir. Fiyatlar sezona ve otele göre 1.200–5.000 TL arasında değişmektedir. Tarihi şehir merkezine yakın bir otel seçmek, çarşılara ve restoranlara yürüme mesafesinde olmanızı sağlar.",
  },
  {
    q: "Gaziantep'ten Şanlıurfa'ya nasıl gidilir?",
    a: "Gaziantep'ten Şanlıurfa'ya otobüsle yaklaşık 2,5–3 saat sürer; sık seferler mevcuttur. Özel araçla ise yaklaşık 2 saat sürer. Şanlıurfa'da Göbeklitepe (12.000 yıllık dünyanın en eski tapınağı), Balıklıgöl ve tarihi çarşı mutlaka görülmesi gereken noktalar arasındadır. Gaziantep–Şanlıurfa–Mardin güzergahı, Güneydoğu Anadolu'nun en zengin kültür turunu oluşturur.",
  },
  {
    q: "Gaziantep'te fotoğraf çekmek için en iyi noktalar nereler?",
    a: "Gaziantep'in en iyi fotoğraf noktaları: Zeugma Mozaik Müzesi'nin 'Çingene Kızı' mozaiği, Gaziantep Kalesi'nin surları ve panoramik manzarası, Bakırcılar Çarşısı'nın el sanatları atölyeleri, Tahmis Kahvesi'nin tarihi avlusu, İmam Çağdaş'ta baklava tepsilerinin dizildiği anlar ve Halfeti'de Fırat Nehri'ne yansıyan gün batımı. Sabah erken saatler ve gün batımı en dramatik ışığı sunar.",
  },
];

const GaziantepFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Gaziantep Seyahat SSS — Baklava, Zeugma ve UNESCO Gastronomi Şehri Rehberi 2026";
    const desc = "Gaziantep'e seyahat planlayanlar için en sık sorulan sorular: Zeugma Mozaik Müzesi, fıstıklı baklava, Halfeti, ulaşım ve konaklama hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/gaziantep-sss");
    setMeta("description", desc);
    setMeta("keywords", "gaziantep seyahat, gaziantep gezilecek yerler, zeugma mozaik muzesi, gaziantep baklava, halfeti, gaziantep sss, guneydogu anadolu rehberi, gaziantep kalesi, gaziantep katmeri, gaziantep beyran, gaziantep lahmacun, gaziantep kebap, antep fistigi, gaziantep tahmis kahvesi, gaziantep bakircılar carsisi, gaziantep zincirli bedesten, gaziantep arkeoloji muzesi, gaziantep ne zaman gidilir, gaziantep konaklama, gaziantep ulasim, gaziantep gunubirlik gezi, halfeti siyah gul, halfeti tekne turu, rumkale, sanliurfa gobeklitepe, gaziantep UNESCO gastronomi sehri, imam cagdas baklava, kocak baklava, gulluoglu, gaziantep mutfagi, guneydogu anadolu turu");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/gaziantep-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Gaziantep%20Turkey%20Zeugma%20mosaic%20museum%20castle%20baklava%20pistachio%20historical%20city%20UNESCO%20gastronomy%20panoramic&width=1200&height=630&seq=gaz-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);
    setMeta("geo.placename", "Gaziantep");
    setMeta("geo.region", "TR-27");

    injectSchema("schema-gaziantep-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-gaziantep-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Gaziantep SSS", "item": "https://geziturkiyem.com/gaziantep-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      ["schema-gaziantep-faq", "schema-gaziantep-breadcrumb"].forEach((id) => {
        document.getElementById(id)?.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Gaziantep%20Turkey%20Zeugma%20mosaic%20museum%20castle%20historical%20city%20baklava%20pistachio%20market%20panoramic%20aerial%20view%20dramatic&width=1400&height=500&seq=gaz-sss-hero&orientation=landscape"
            alt="Gaziantep"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Gaziantep SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Gaziantep Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            UNESCO Gastronomi Şehri Gaziantep&apos;e seyahat planlayanların en çok merak ettiği sorular ve kapsamlı Güneydoğu rehberi.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-restaurant-2-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Gaziantep Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Gaziantep, UNESCO Yaratıcı Şehirler Ağı&apos;nın gastronomi üyesi olup dünyanın en büyük mozaik müzesine, 2.000 yıllık bir kaleye ve Türkiye&apos;nin en zengin çarşı kültürüne sahip bir şehirdir. Fıstıklı baklavası, katmeri ve beyran çorbasıyla Türkiye&apos;nin tartışmasız gastronomi başkentidir.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/mardin-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-ancient-gate-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Mardin SSS</p>
            <p className="text-xs text-stone-400">Taş evler ve manastırlar rehberi</p>
          </Link>
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
          <Link to="/kapadokya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-landscape-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kapadokya SSS</p>
            <p className="text-xs text-stone-400">Peri bacaları ve balon turları</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GaziantepFaq;
